/* Progressive navigation only: article text, sources and links work without JS. */
(() => {
  function init(root) {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    const german = root.lang.toLowerCase().split('-')[0] === 'de';
    const english = root.lang.toLowerCase().split('-')[0] === 'en';
    const polish = root.lang.toLowerCase().split('-')[0] === 'pl';
    const outline = root.querySelector('[data-guide-outline]');
    if (!outline) return;
    const mobile = window.matchMedia('(max-width: 900px)');
    const sync = () => { outline.open = !mobile.matches; };
    sync();
    mobile.addEventListener('change', sync);
    outline.addEventListener('click', (event) => {
      if (event.target.closest('a[href^="#"]') && mobile.matches) outline.open = false;
    });
    const links = [...outline.querySelectorAll('a[href^="#"]')];
    const targets = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
    const progress = root.querySelector('[data-guide-progress]');
    const journey = root.querySelector('[data-guide-journey]');
    const chapterBody = root.querySelector('.bk-guide-chapters');
    const progressBar = progress?.parentElement;
    const scrubber = root.querySelector('[data-guide-scrubber]');
    let readingStart = 0, readingEnd = 1;
    const percentage = root.querySelector('[data-guide-percent]');
    const journeyLabel = root.querySelector('[data-guide-journey-label]');
    const topLink = root.querySelector('[data-guide-top]');
    const topPercent = root.querySelector('[data-guide-top-percent]');
    const sidebar = root.querySelector('.bk-guide-outline');
    const stickyHeader = document.getElementById('sticky-header');
    const mobileNav = document.querySelector('.bls__mobile-stickybar');
    const pageHeader = document.getElementById('page-header');
    let currentLink = null, revealCurrent = false;
    let queued = false;
    function revealOutlineLink(link) {
      if (!link || !outline.open) return;
      const panel = outline.getBoundingClientRect();
      const item = link.getBoundingClientRect();
      const visibleTop = panel.top + (outline.querySelector('summary')?.offsetHeight || 0) + 8;
      const visibleBottom = panel.bottom - 8;
      // Scroll only the contents panel; scrollIntoView would also move the article.
      if (item.top < visibleTop) outline.scrollTop += item.top - visibleTop;
      else if (item.bottom > visibleBottom) outline.scrollTop += item.bottom - visibleBottom;
    }
    function update() {
      queued = false;
      let active = targets[0];
      let headerBottom = 0;
      if (stickyHeader && !mobile.matches) {
        const box = stickyHeader.getBoundingClientRect();
        const position = getComputedStyle(stickyHeader).position;
        if ((position === 'fixed' || position === 'sticky') && box.top <= 1 && box.bottom > 0) headerBottom = box.bottom;
        // Reserve the enabled sticky header before it attaches, including anchor jumps.
        const enabled = pageHeader?.dataset.sticky === 'true' && (innerWidth >= 1025 || pageHeader?.dataset.stickyMobile === 'true');
        if (enabled) headerBottom = Math.max(headerBottom, box.height);
      }
      root.style.setProperty('--guide-mobile-top', `${headerBottom}px`);
      root.style.setProperty('--guide-sticky-top', `${headerBottom + 20}px`);
      const navBox = mobileNav?.getBoundingClientRect();
      const bottomOffset = mobile.matches && navBox && navBox.height && navBox.top < innerHeight && navBox.bottom >= innerHeight - 2 ? navBox.height + 16 : 24;
      root.style.setProperty('--guide-bottom-offset', `${bottomOffset}px`);
      const offset = mobile.matches ? headerBottom + (sidebar?.querySelector('.bk-guide-reader-heading')?.offsetHeight || 0) + (outline.querySelector('summary')?.offsetHeight || 0) + 36 : headerBottom + 24;
      root.style.setProperty('--guide-offset', `${Math.min(offset, innerHeight * .8)}px`);
      for (const target of targets) {
        if (target.getBoundingClientRect().top <= offset + 30) active = target;
      }
      const activeLink = links.find(link => active && link.hash === '#' + active.id);
      links.forEach(link => {
        if (link === activeLink) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (activeLink !== currentLink || revealCurrent) revealOutlineLink(activeLink);
      currentLink = activeLink;
      revealCurrent = false;
      if (progress && targets.length) {
        const start = readingStart = targets[0].getBoundingClientRect().top + window.scrollY - offset;
        const end = readingEnd = (chapterBody || root).getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
        // Browsers round scroll positions to physical pixels. Snap the endpoints.
        const value = window.scrollY >= end - 1 ? 100 : window.scrollY <= start + 1 ? 0 : Math.max(0, Math.min(100, (window.scrollY - start) / Math.max(1, end - start) * 100));
        progress.style.width = `${value}%`;
        progressBar.style.setProperty('--guide-progress', `${value}%`);
        if (scrubber) {
          scrubber.value = String(Math.round(value));
          scrubber.setAttribute('aria-valuetext', german ? `${Math.round(value)} % des Ratgebers` : english ? `${Math.round(value)}% of the guide` : polish ? `${Math.round(value)}% poradnika` : `${Math.round(value)} % gido`);
        }
        if (percentage) percentage.textContent = `${Math.floor(value)} %`;
        if (journey) journey.dataset.complete = String(value >= 100);
        if (journeyLabel) journeyLabel.textContent = german ? (value >= 100 ? 'Ende des Ratgebers. Danke fürs Lesen.' : 'Lesefortschritt') : english ? (value >= 100 ? 'End of the guide. Thanks for reading.' : 'Reading progress') : polish ? (value >= 100 ? 'Koniec poradnika. Dziękujemy za lekturę.' : 'Postęp czytania') : (value >= 100 ? 'Gido pabaiga. Bebras patenkintas.' : 'Gido kelias');
        if (topPercent) topPercent.textContent = `${Math.floor(value)} %`;
        if (topLink) {
          topLink.hidden = window.scrollY < start || root.getBoundingClientRect().bottom < 0;
          topLink.style.setProperty('--guide-position', value / 100);
        }
      }
    }
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    resizeObserver?.observe(root);
    if (stickyHeader) resizeObserver?.observe(stickyHeader);
    update();
    scrubber?.addEventListener('input', () => {
      const requested = Number(scrubber.value);
      // Refresh the shared reading bounds after responsive changes or image loads.
      update();
      window.scrollTo({ top: Math.max(0, readingStart + Math.max(1, readingEnd - readingStart) * requested / 100), behavior: 'instant' });
      revealCurrent = true;
      update();
    });
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      const target = link && document.getElementById(link.hash.slice(1));
      if (target) {
        if (link.matches('[data-guide-top]')) {
          event.preventDefault();
          window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY), behavior: 'instant'});
          if (mobile.matches) outline.open = false;
        }
        target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true });
      }
    });
    outline.addEventListener('toggle', () => { revealCurrent = true; schedule(); });
    outline.addEventListener('keydown', event => {
      if (event.key === 'Escape' && mobile.matches && outline.open) { outline.open = false; outline.querySelector('summary')?.focus(); }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', sync);
      resizeObserver?.disconnect();
    }, { once: true });
  }
  document.querySelectorAll('[data-bk-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bk-guide]').forEach(init));
})();
